import { Box, Grid } from "@mui/material";
import {
	BusinessNumberRHF,
	EmailFieldRHF,
	EnhancedCheckboxRHF,
	EnhancedCheckboxRHFWithLabel,
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	ExtensionNumber,
	ExtensionNumberRHF,
	LabelPosition,
	PhoneNumberRHF,
	PostCodeRHF,
	RHookFormDatePicker,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
	ReducedElAccountNumberRHF,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../../../common/constants";

import { CityService } from "../../../../services/CityService";
import { CountryService } from "../../../../services/common/CountryService";
import { ProvinceService } from "../../../../services/common/ProvinceService";
import { StateService } from "../../../../services/common/USAStateService";
import { sortDDLByLabel, useNavigateToLogout } from "../../../../common/Common";
import { useQuery } from "@tanstack/react-query";

// import { RHookFormDatePicker } from "../../../RHookFormDatePicker";





interface IAccountantAddressSetupFieldsPanel {
	countryList: {
		shortCode?: string;
		label: string;
		value: string;
		countryType: string;
	}[];
	provinceDDLLoading: (value: boolean) => void;
	formMethods: any;
	provinceStateDDLinUpdate: any;
	cityDDLinUpdate: any;
	provinceStateLabelinUpdate: any;
	isAdminUser: any;
}
export const AccountantAddressSetupFieldsPanel: FC<
	IAccountantAddressSetupFieldsPanel
> = ({
	countryList,
	provinceDDLLoading,
	formMethods,
	provinceStateDDLinUpdate,
	cityDDLinUpdate,
	provinceStateLabelinUpdate,
	isAdminUser,
}) => {
		const [provinceOrStateDDL, setprovinceOrStateDDL] = useState(undefined);
		const [cityDDL, setCityDDL] = useState(undefined);
		const [countrytype, setCountrytype] = useState("Province");
		const [selectedCountryShortCode, setSelectedCountryShortCode] = useState("");
		const [selectedCountry, setSelectedCountry] = useState<any>("");
		// const useGetProvinceDDL = () => {
		// 	return useQuery(GET_QUERY_KEY.PROVINCE_DDL, () => ProvinceService.get(), {
		// 		...QUERY_OPTIONS,
		// 	});
		// };
		// const { data: provinceList } = useGetProvinceDDL();
		const navigateToLogout = useNavigateToLogout();

		// const useGetCountryDDL = () => {
		//   return useQuery(GET_QUERY_KEY.COUNTRY_DDL, () => CountryService.get(), {
		//     ...QUERY_OPTIONS,
		//   });
		// };
		// const { data: countryList } =
		// useGetCountryDDL();

		// const useGetStateDDL = () => {
		// 	return useQuery(GET_QUERY_KEY.USA_STATE_DDL, () => StateService.get(), {
		// 		...QUERY_OPTIONS,
		// 	});
		// };
		// const { data: stateList } = useGetStateDDL();

		const onCountryChangeHandler = async (e: any) => {

			setSelectedCountryShortCode(e.shortCode);
			setSelectedCountry(e.value);
			let selected = e.value;
			setCountrytype(
				e.countryType === "province"
					? "Province"
					: e.countryType === "state"
						? "State"
						: e.countryType
			);
			formMethods.setValue("province", undefined);
			formMethods.setValue("state", undefined);
			try {
				provinceDDLLoading(true);
				const responce = await CountryService.getProvinceOrStateDDL(
					navigateToLogout,
					selected,
					e.countryType
				);
				setprovinceOrStateDDL(responce);
			} catch {
			} finally {
				provinceDDLLoading(false);
			}
		};

		const onProvinceChangeHandler = async (e: any) => {
			let selected = e.value;
			formMethods.setValue("city", undefined);
			try {
				provinceDDLLoading(true);
				const responce = await CityService.getCityDDL(navigateToLogout, selected);
				setCityDDL(responce);
			} catch {
			} finally {
				provinceDDLLoading(false);
			}
		};

		useEffect(() => {
			if (provinceStateDDLinUpdate && provinceStateLabelinUpdate) {
				setprovinceOrStateDDL(provinceStateDDLinUpdate);
				setCountrytype(
					provinceStateLabelinUpdate === "province"
						? "Province"
						: provinceStateLabelinUpdate === "state"
							? "State"
							: provinceStateLabelinUpdate
				);
				setSelectedCountryShortCode(
					provinceStateLabelinUpdate === "province"
						? "CAN"
						: provinceStateLabelinUpdate === "state"
							? "USA"
							: provinceStateLabelinUpdate
				);
			}
			if (cityDDLinUpdate) {
				setCityDDL(cityDDLinUpdate);
			}
			if (countryList && Array.isArray(countryList)) {
				const canada = countryList.find(
					(item: any) => item.label === "Canada" || "canada"
				);
				if (canada) {
					setSelectedCountry(canada.value);
					setSelectedCountryShortCode(canada.shortCode ? canada.shortCode : "");
					(async () => {
						try {
							provinceDDLLoading(true);
							const response = await CountryService.getProvinceOrStateDDL(
								navigateToLogout,
								canada.value,
								"Province"
							);
							setprovinceOrStateDDL(response);
							//   provinceDDLItems(response);
						} catch (err) {
							console.error("error", err);
						} finally {
							provinceDDLLoading(false);
						}
					})();
				}
			}
		}, [
			provinceStateLabelinUpdate,
			provinceStateDDLinUpdate,
			countryList,
			cityDDLinUpdate,
		]);


		return (
			<div style={{ padding: "0" }}>
				<RHookFormTextFieldWithLabel
					label="Address"
					id="addressLine1"
					testId={`accountant-addressLine1`}
					labelPosition={LabelPosition.Top}
					// required
					labelColumns={4}
					fieldColumns={8}
				/>
				{/* <RHookFormTextFieldWithLabel
				label="City"
				id="city"
				testId={`accountant-city`}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
				// required
			/> */}
				{/* <RHookFormTextFieldWithLabel
            label="Country"
            id="countryId"
            testId={`accountant-country`}
            labelPosition={LabelPosition.Top}
            value="Canada"
            defaultValue={"Canada"}
            readOnly
            required
            labelColumns={4}
            fieldColumns={8}
          /> */}
				{/* <EnhancedDropDownRHFWithLabel
				selectName="country"
				label="Country"
				labelPosition={LabelPosition.Top}
				// required
				testId={`country-list`}
				items={countryList ?? []}
				// selectedItem={selectedCountry}
				labelColumns={4}
				fieldColumns={8}
				onSelectionChangeHandler={onCountryChangeHandler}
			/> */}
				{countryList && selectedCountry && (
					<EnhancedDropDownRHFWithLabel
						selectName="country"
						label="Country"
						labelPosition={LabelPosition.Top}
						// required
						testId={`country-list`}
						items={countryList ?? []}
						selectedItem={selectedCountry}
						labelColumns={4}
						fieldColumns={8}
						onSelectionChangeHandler={onCountryChangeHandler}
					/>
				)}

				{provinceOrStateDDL && (
					<EnhancedDropDownRHFWithLabel
						selectName={"province"}
						label={countrytype}
						labelPosition={LabelPosition.Top}
						// required
						testId={`province-list`}
						items={provinceOrStateDDL ?? []}
						labelColumns={4}
						fieldColumns={8}
						onSelectionChangeHandler={onProvinceChangeHandler}
					/>
				)}

				{provinceOrStateDDL && cityDDL && (
					<EnhancedDropDownRHFWithLabel
						selectName={"city"}
						label={"City"}
						labelPosition={LabelPosition.Top}
						// required
						testId={`city-list`}
						items={ cityDDL && sortDDLByLabel(cityDDL ?? [])}
					/>
				)}

				{selectedCountryShortCode === "CAN" ? (
					<PostCodeRHF
						label="Post Code"
						id="postCode"
						testId={`accountant-post-code`}
						labelPosition={LabelPosition.Top}
						labelColumns={4}
						fieldColumns={8}
					// required
					/>
				) : selectedCountryShortCode === "USA" ? (
					<RHookFormMaskedTextFieldWithLabel
						label="Zip Code"
						id="zipCode"
						testId={`Zip-Code`}
						labelPosition={LabelPosition.Top}
						placeholder={"00000"}
						// required
						inputMaskPattern={"00000"}
						labelColumns={4}
						fieldColumns={8}
					/>
				) : (
					<></>
				)}
				{/* {selectedCountryShortCode !== "" && (selectedCountryShortCode === "CAN") || (selectedCountryShortCode === "USA") ? <RHookFormMaskedTextFieldWithLabel
                        label={selectedCountryShortCode === "USA" ? "Zip Code" : selectedCountryShortCode === "CAN" ? "Postal Code" : ""}
                        id={selectedCountryShortCode === "USA" ? "zipCode" : selectedCountryShortCode === "CAN" ? "postalCode" : ""}
                        testId={`Zip-Code`}
                        labelPosition={LabelPosition.Top}
                        placeholder={selectedCountryShortCode === "USA" ? "00000" : selectedCountryShortCode === "CAN" ? "A0A0A0" : ""}
                        required
                        inputMaskPattern={selectedCountryShortCode === "USA" ? "00000" : selectedCountryShortCode === "CAN" ? "a0a0a0" : ""}
                        labelColumns={4}
                        fieldColumns={8}
                      /> : <></>} */}

				{isAdminUser === 400 && <EnhancedDropDownRHFWithLabel
					label="Support Access level can manage"
					selectName="supportAccessLevelCanManage"
					testId={`accountant-supportAccessLevelCanManage`}
					labelPosition={LabelPosition.Top}
					items={[
						{ label: "Yes", value: 200 },
						{ label: "No", value: 100 },
					]}
					// value="Canada"
					selectedItem={100}
					// readOnly
					// required
					labelColumns={4}
					fieldColumns={8}
				/>}

				{isAdminUser === 400 && <EnhancedDropDownRHFWithLabel
					label="Type"
					selectName="type"
					testId={`accountant-type`}
					labelPosition={LabelPosition.Top}
					items={[
						{ label: "Live", value: 100 },
						{ label: "Test", value: 200 },
					]}
					// value="Canada"
					selectedItem={100}
					// readOnly
					// required
					labelColumns={4}
					fieldColumns={8}
				/>}

				{/* <EnhancedCheckboxRHFWithLabel */}
				{isAdminUser === 400 && <EnhancedCheckboxRHF
					name="activateAccount"
					checked={false}
					testId="Activate-Account"
					// labelPosition={LabelPosition.Left}
					// labelColumns={4}
					// fieldColumns={8}
					// label={"Activate Account"}
					checkboxLabel="Activate Account"
				/>}
				{/* <EnhancedCheckboxRHF
				name="defaultAccountant"
				checked={false}
				testId="Default-Accountant"
				checkboxLabel="Default Accountant"
			/> */}
			</div>
		);
	};
